import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Rating,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

// import React from 'react';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const taxzeronevssimple990 = () => {
  // const containerRef = useRef(null);

  // const [currentImageIndex, setCurrentImageIndex] = useState(0);
  // const [removelistener, setRemovelistener] = useState(true);
  // const [tempReturn, setTempReturn] = useState(false);
  // Define an array of imported images
  // const images = [
  //   '/assets/images/2290-steps-img.webp',
  //   '/assets/images/easy-steps-img.webp',
  //   '/assets/images/941-steps-img.webp',

  // ];
  // const Ref = React.useRef<HTMLDivElement>(null);

  // Handle scrolling to change images
  // const handleScroll = (event: any) => {
  //   const delta = event.deltaY;
  //   if (delta > 0) {
  //     // Scroll down, show the next imag
  //     if (currentImageIndex < 2) {
  //       setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  //       setRemovelistener(false);
  //     } else {
  //       setRemovelistener(true);
  //     }
  //   } else if (delta < 0) {
  //     // Scroll up, show the previous image
  //     if (currentImageIndex > 0) {
  //       setCurrentImageIndex((prevIndex) =>
  //         prevIndex === 0 ? images.length - 1 : prevIndex - 1
  //       );
  //       setRemovelistener(false);
  //     } else {
  //       setRemovelistener(true);
  //     }
  //   } else {
  //     setRemovelistener(false);
  //   }
  // };
  // function useHorizontalScroll() {
  //   useEffect(() => {
  //     const el = Ref.current;
  //     setTempReturn(tempReturn);
  //     if (el) {
  //       const onWheel = (e: any) => {
  //         if (e.deltaY === 0) return;
  //         e.preventDefault();
  //         el.scrollTo({
  //           behavior: 'smooth',
  //           top: 0,
  //           left: 0,
  //         });
  //       };

  //       el.addEventListener('wheel', onWheel);
  //       if (removelistener === false) {
  //         el.addEventListener('wheel', onWheel);
  //       } else if (removelistener === true) {
  //         el.removeEventListener('wheel', onWheel);
  //       } else {
  //         el.addEventListener('wheel', onWheel);
  //       }
  //       return () => {
  //         el.removeEventListener('wheel', onWheel);
  //       };
  //     }
  //     return () => setTempReturn(false);
  //   }, [removelistener]);
  //   return Ref;
  // }

  // const scrollRef = useHorizontalScroll();

  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="TaxZerone vs Simple990: Compare Features, Pricing & More"
          description="Explore the differences between TaxZerone and Simple990. Compare Form 990 support, pricing, security, filing tools, and overall user experience."
          keywords=""
          canonical="comparison/taxzerone-vs-simple990/"
          // noFollowContent="noindex, nofollow"
          // jsonLdPricing="89.99"
          // jsonLdAggregateRatingValue="4.99"
          // jsonLdAggregateRatingCount="3021"
        />
      }
    >
      <Box
        component="section"
        sx={{
          mt: 0,
          pt: 8,
          pb: 8,
          position: 'relative',
          background: `
  linear-gradient(180deg,rgba(34, 62, 152, 0.32) 0%, rgba(243, 113, 40, 0.08) 66%, rgba(255, 255, 255, 0.34) 97%)
`,
          overflow: 'hidden',
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            alignContent: 'center',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          <Box
            sx={{
              textAlign: 'center',
              mt: 4,
              mb: 4,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                backgroundColor: 'rgb(33, 62, 153, 0.1)',
                color: '#213E99',
                border: '1px solid #5c74c4',
                display: 'inline-block',
                px: 4,
                py: 1,
                borderRadius: 24,
                alignItems: 'center',
                mb: 2,
              }}
            >
              <Box
                component="span"
                sx={{
                  width: 8,
                  height: 8,
                  minWidth: 8,
                  borderRadius: '50%',
                  backgroundColor: '#213e99',
                  display: 'inline-block',
                  gap: 2,
                  animation:
                    'pulseDot 3.8s cubic-bezier(0.5, 0, 0.6, 1) infinite',

                  '@keyframes pulseDot': {
                    '0%': {
                      transform: 'scale(0.5)',
                      boxShadow: '0 0 0 0 rgba(33, 62, 153, 0.5)',
                    },
                    '50%': {
                      transform: 'scale(1.1)',
                      boxShadow: '0 0 0 7px rgba(33, 62, 153, 0)',
                    },
                    '100%': {
                      transform: 'scale(0.5)',
                      boxShadow: '0 0 0 0 rgba(33, 62, 153, 0)',
                    },
                  },
                }}
              />
              &nbsp; Nonprofit E-Filing Comparison 2025
            </Typography>
            <Typography
              variant="h1"
              sx={{
                fontSize: {
                  xs: 24,
                  sm: 30,
                  md: 38,
                  lg: 48,
                  xl: 56,
                },
                fontWeight: 700,
                color: '#1a1a1a',
                mb: 3,
                lineHeight: 1.2,
              }}
            >
              TaxZerone <span style={{ color: '#5B4FCB' }}> vs</span> Simple990
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontSize: {
                  xs: 16,
                  sm: 18,
                  md: 20,
                  lg: 22,
                  xl: 24,
                },
                fontWeight: 400,
                mb: 1,
                // color: '#5b6472',
                lineHeight: 1.5,
                maxWidth: 1100,
                mx: 'auto',
              }}
            >
              <strong style={{ fontWeight: 600 }}>
                {' '}
                Which Is Right for Your Nonprofit?
              </strong>{' '}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: {
                  xs: 16,
                  sm: 16,
                  md: 18,
                  lg: 18,
                },
                fontWeight: 'normal',
                mb: 4,
                // color: '#5b6472',
                lineHeight: 1.5,
                maxWidth: 1100,
                mx: 'auto',
              }}
            >
              A thorough, feature-by-feature comparison of two IRS-authorized
              e-filing platforms -
              <br />
              covering forms supported, pricing, workflow tools, and security
              certifications.
            </Typography>

            <Button
              variant="contained"
              className="btn-primary"
              sx={{
                backgroundColor: '#1e2f8f',
                color: '#ffffff',
                fontWeight: 500,
                fontSize: 16,
                px: 4,
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                boxShadow: 'none',
                transition: 'all 0.3s ease',
                '&:hover, &:focus, &:active': {
                  backgroundColor: '#16247a',
                  transform: 'scale(1.05)',
                },
              }}
              href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=taxzerone-vs-simple990`}
            >
              Start Filling for FREE
            </Button>
          </Box>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
        aria-labelledby="side-by-side"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Grid size={12} textAlign="center">
                <Box
                  sx={{
                    textAlign: 'center',
                    px: 3,
                    py: 0.8,
                    mb: 1.5,
                    borderRadius: '30px',
                    backgroundColor: '#effff4',
                    color: '#1da94a',
                    border: '1px solid #1da94a',
                    // fontWeight: 600,
                    display: 'inline-block',
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: { xs: 12, sm: 13, md: 14 },
                      letterSpacing: '0.5px',
                      lineHeight: 1.2,
                    }}
                  >
                    Feature Comparison
                  </Typography>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: {
                      xs: 20,
                      sm: 28,
                      md: 32,
                      lg: 38,
                    },
                    fontWeight: 600,
                    mb: 1,
                    textAlign: 'center',
                    lineHeight: 1.5,
                  }}
                >
                  Complete Side-by-Side Breakdown
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: {
                      xs: 16,
                      sm: 18,
                      md: 18,
                      lg: 20,
                      xl: 22,
                    },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                    textAlign: 'center',
                  }}
                >
                  Every feature that matters for exempt organization{' '}
                  <Hidden smDown>
                    {' '}
                    <br />{' '}
                  </Hidden>
                  e-filing - sourced directly from each platform's official
                  feature set.
                </Typography>
              </Grid>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                Filing & Form Support
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                The forms and filing options available to help you complete your
                return
              </Typography>
              <TableContainer
                sx={{
                  // border: '1px solid #e2e8f0',
                  overflowX: {
                    xs: 'auto',
                    md: 'unset',
                  },
                  // background: '#ffffff',
                  // boxShadow: '0 8px 40px rgba(0, 0, 0, 0.2)',
                  mx: 'auto',
                  width: '100%',
                  // borderRadius: '12px',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{}}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',

                      width: '100%',
                      borderSpacing: 0,

                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        borderBottom: '1px solid #ccc',
                      },
                      '& tbody tr td': { verticalAlign: 'middle' },
                    }}
                  >
                    <TableHead sx={{}}>
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,
                            borderBottom: '2px solid #213e99  !important',
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                            // borderTopLeftRadius: 24,
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                            backgroundColor: '#e1f4fb !important',
                            color: '#333',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          Available Forms & Returns
                        </TableCell>

                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            backgroundColor: '#f7f9f9 !important',
                            color: '#333',
                            borderRight: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                              color: '#333',
                            }}
                          >
                            Simple990
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        // borderBottom: '1px solid #ccc',
                        // borderRadius: '42px !important',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow
                        sx={{
                          // borderTopRightRadius: 4,
                          backgroundColor: '#f5f5f5',
                        }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            // borderTop: ' 1px solid #ccc !important',
                            // borderTopLeftRadius: '12px',
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Form 990-N (e-Postcard){' '}
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Supported &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Form 990-EZ
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Supported &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Form 990
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Supported &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            textAlign: 'left',
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Form 990-PF
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            textAlign: 'left',
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Form 990-T
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Form 1120-POL
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Form 5227
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Form 8868 (Extension)
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Form 8050
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          CA Form 199 (State)
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          CA Form 109 (State)
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Free
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          990 Schedules (auto-generated)
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Supported &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          990 Amended Returns
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Multi-Year Filing (2023–2025)
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Supported &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                Data Intake & Filing Tools
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                The tools available to simplify data entry, importing, and
                filing
              </Typography>
              <TableContainer
                sx={{
                  // border: '1px solid #e2e8f0',
                  overflowX: {
                    xs: 'auto',
                    md: 'unset',
                  },
                  background: '#ffffff',
                  // boxShadow: '0 8px 40px rgba(0, 0, 0, 0.2)',
                  mx: 'auto',
                  width: '100%',
                  // borderRadius: '12px',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{}}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',

                      width: '100%',
                      borderSpacing: 0,

                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        borderBottom: '1px solid #ccc',
                      },
                      '& tbody tr td': { verticalAlign: 'middle' },
                    }}
                  >
                    <TableHead sx={{}}>
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,
                            borderBottom: '2px solid #213e99  ',
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                            // borderTopLeftRadius: 24,
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                            backgroundColor: '#e1f4fb !important',
                            color: '#333',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          Data & Filing Capabilities
                        </TableCell>

                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            backgroundColor: '#f7f9f9 !important',
                            color: '#333',
                            borderRight: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                              color: '#333',
                            }}
                          >
                            Simple990
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        borderBottom: '1px solid #ccc',
                        // borderTop: '1px solid #ccc',
                        // borderRadius: '12px !important',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow
                        sx={{
                          borderTopRightRadius: 3,
                          backgroundColor: '#f5f5f5',
                        }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            borderTop: ' 1px solid #ccc !important',
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>

                            <Box>Available</Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          IRS2File
                          <br />
                          <Typography
                            component="div"
                            sx={{
                              backgroundColor: '#ECEAFB',
                              color: '#332C74',
                              border: '1px solid #D9D5F5',
                              fontWeight: 600,
                              fontSize: 11,
                              px: 1,
                              py: 0.2,
                              mt: 0.5,
                              borderRadius: 4,
                              display: 'inline-block',
                            }}
                          >
                            ★ Only TaxZerone
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 1,
                              justifyContent: 'flex-end',
                            }}
                          >
                            <Box> Not Supported Currently</Box>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#FCEEEF',
                                border: '1px solid #F2CBCF',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#C63C4A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                x
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            <Box>Available</Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Click2File
                          <br />
                          <Typography
                            component="div"
                            sx={{
                              backgroundColor: '#ECEAFB',
                              color: '#332C74',
                              border: '1px solid #D9D5F5',
                              fontWeight: 600,
                              fontSize: 11,
                              px: 1,
                              py: 0.2,
                              mt: 0.5,
                              borderRadius: 4,
                              display: 'inline-block',
                            }}
                          >
                            ★ Only TaxZerone
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right ' }}>
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 1,
                              justifyContent: 'flex-end',
                            }}
                          >
                            <Box>Not Supported Currently</Box>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#FCEEEF',
                                border: '1px solid #F2CBCF',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#C63C4A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                x
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Available
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Form-based direct entry
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            <Box>Available</Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          EIN Lookup / IRS Data Import
                          <br />
                          <Typography
                            component="div"
                            sx={{
                              backgroundColor: '#ECEAFB',
                              color: '#332C74',
                              border: '1px solid #D9D5F5',
                              fontWeight: 600,
                              fontSize: 11,
                              px: 1,
                              py: 0.2,
                              mt: 0.5,
                              borderRadius: 4,
                              display: 'inline-block',
                            }}
                          >
                            ★ Only TaxZerone
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right ' }}>
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 1,
                              justifyContent: 'flex-end',
                            }}
                          >
                            <Box>Not Supported Currently</Box>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#FCEEEF',
                                border: '1px solid #F2CBCF',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#C63C4A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                x
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Available
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          E-signature (8453-TE / 8879-TE)
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Available
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          EIN Finder
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                Validation & Security
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                How the platform checks your return and keeps your filing data
                secure
              </Typography>
              <TableContainer
                sx={{
                  // border: '1px solid #e2e8f0',
                  overflowX: {
                    xs: 'auto',
                    md: 'unset',
                  },
                  background: '#ffffff',
                  // boxShadow: '0 8px 40px rgba(0, 0, 0, 0.2)',
                  mx: 'auto',
                  width: '100%',
                  // borderRadius: '12px',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{ minWidth: '840px' }}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',

                      width: '100%',
                      borderSpacing: 0,

                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        borderBottom: '1px solid #ccc',
                      },
                      '& tbody tr td': { verticalAlign: 'middle' },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderBottom: '2px solid #213e99',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#333',

                            backgroundColor: '#e1f4fb !important',
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          Error Checks & Security
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            borderRight: '1px solid #ccc',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                              // color: '#0f172a',
                            }}
                          >
                            Simple990
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        // borderBottom: '1px solid #ccc',
                        // borderTop: '1px solid #ccc',
                        // borderRadius: '12px !important',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow
                        sx={{
                          borderTopRightRadius: 3,
                          backgroundColor: '#f5f5f5',
                        }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            borderTop: ' 1px solid #ccc !important',
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>

                            <Box>Available</Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Built-in IRS Error / Audit Check
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Available &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            <Box>Authorized</Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          IRS-Authorized E-File Provider <br />
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Authorized &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          SOC 2 Certification
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            <Box>Supported</Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Two-Factor Authentication (2FA)
                          <br />
                          <Typography
                            component="div"
                            sx={{
                              backgroundColor: '#ECEAFB',
                              color: '#332C74',
                              border: '1px solid #D9D5F5',
                              fontWeight: 600,
                              fontSize: 11,
                              px: 1,
                              py: 0.2,
                              mt: 0.5,
                              borderRadius: 4,
                              display: 'inline-block',
                            }}
                          >
                            ★ Only TaxZerone
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right ' }}>
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 1,
                              justifyContent: 'flex-end',
                            }}
                          >
                            <Box>Not Supported Currently</Box>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#FCEEEF',
                                border: '1px solid #F2CBCF',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#C63C4A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                x
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                Post-Filing & Support
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                The tools and support available after you submit your return
              </Typography>
              <TableContainer
                sx={{
                  // border: '1px solid #e2e8f0',
                  overflowX: {
                    xs: 'auto',
                    md: 'unset',
                  },
                  background: '#ffffff',
                  // boxShadow: '0 8px 40px rgba(0, 0, 0, 0.2)',
                  mx: 'auto',
                  width: '100%',
                  // borderRadius: '12px',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{ minWidth: '840px' }}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',

                      width: '100%',
                      borderSpacing: 0,

                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        borderBottom: '1px solid #ccc',
                      },
                      '& tbody tr td': { verticalAlign: 'middle' },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderBottom: '2px solid #213e99',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#333',
                            backgroundColor: '#e1f4fb !important',
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          Filing Assistance & Access
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#333',

                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            borderRight: '1px solid #ccc',
                            backgroundColor: '#f7f9f9 !important',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                              // color: '#0f172a',
                            }}
                          >
                            Simple990
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        // borderBottom: '1px solid #ccc',
                        // borderTop: '1px solid #ccc',
                        // borderRadius: '12px !important',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow
                        sx={{
                          borderTopRightRadius: 3,
                          backgroundColor: '#f5f5f5',
                        }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            borderTop: ' 1px solid #ccc !important',
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            <Box>Free</Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Free Retransmission on Rejection
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Available &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            <Box>Available</Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Real-Time IRS Status (Email) <br />
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Available &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Available
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Filing History / Return Archive
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Available
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Deadline Reminders
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Available &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Available
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Record Keeping
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Available &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Email Support
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Supported &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Live Chat Support
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Supported
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Phone Support
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                Professional & Organization Tools
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Features designed to support tax professionals and organization
                management
              </Typography>
              <TableContainer
                sx={{
                  // border: '1px solid #e2e8f0',
                  overflowX: {
                    xs: 'auto',
                    md: 'unset',
                  },
                  background: '#ffffff',
                  // boxShadow: '0 8px 40px rgba(0, 0, 0, 0.2)',
                  mx: 'auto',
                  width: '100%',
                  // borderRadius: '12px',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{ minWidth: '840px' }}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',
                      width: '100%',
                      borderSpacing: 0,
                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        borderBottom: '1px solid #ccc',
                      },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderBottom: '2px solid #213e99',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#333',
                            backgroundColor: '#e1f4fb !important',
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          Workflow & Customization Tools
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            borderRight: '1px solid #ccc',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                              // color: '#0f172a',
                            }}
                          >
                            Simple990
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        // borderBottom: '1px solid #ccc',
                        // borderTop: '1px solid #ccc',
                        // borderRadius: '12px !important',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Available
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Tax Professional Tools
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Available
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Logo & Brand Customization
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                Pricing & Payment
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Payment options and flexibility for managing filing costs
              </Typography>
              <TableContainer
                sx={{
                  // border: '1px solid #e2e8f0',
                  overflowX: {
                    xs: 'auto',
                    md: 'unset',
                  },
                  background: '#ffffff',
                  // boxShadow: '0 8px 40px rgba(0, 0, 0, 0.2)',
                  mx: 'auto',
                  width: '100%',
                  // borderRadius: '12px',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{ minWidth: '840px' }}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',
                      width: '100%',
                      borderSpacing: 0,
                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        borderBottom: '1px solid #ccc',
                      },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderBottom: '2px solid #213e99',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#333',

                            backgroundColor: '#e1f4fb !important',
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          Payment Options & Flexibility
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            borderRight: '1px solid #ccc',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                              // color: '#0f172a',
                            }}
                          >
                            Simple990
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        // borderBottom: '1px solid #ccc',
                        // borderTop: '1px solid #ccc',
                        // borderRadius: '12px !important',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Available
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Pay in Advance
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Free
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          PayPal Payment Option
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Supported Currently &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>
              <Alert
                icon={false}
                sx={{
                  backgroundColor: '#e0f2fe', // Light cyan background matching image
                  color: '#334155', // Soft slate text color
                  fontSize: { xs: '12px', sm: '13px' },
                  lineHeight: 1.5,
                  borderRadius: '12px',
                  padding: '12px 18px',
                  alignItems: 'center',
                  mb: 4,
                  width: '100%',
                  boxShadow: 'none',
                  '& .MuiAlert-icon': {
                    mr: 1.5,
                    padding: 0,
                  },
                  '& .MuiAlert-message': {
                    padding: 0,
                  },
                }}
              >
                <b>Disclaimer:</b> Competitor names and brands belong to their
                respective owners. All comparison details are based on publicly
                available information and may change over time. TaxZerone is not
                affiliated with or endorsed by any platform mentioned on this
                page.
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f6f6fa',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5, mt: 5 }}>
          <Grid size={12} textAlign="center">
            <Box
              sx={{
                textAlign: 'center',
                px: 3,
                py: 0.8,
                mb: 1.5,
                borderRadius: '30px',
                backgroundColor: '#effff4',
                color: '#1da94a',
                border: '1px solid #1da94a',
                fontWeight: 600,
                display: 'inline-block',
              }}
            >
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: { xs: 12, sm: 13, md: 14 },
                  letterSpacing: '0.5px',
                  lineHeight: 1.2,
                }}
              >
                Pricing
              </Typography>
            </Box>
            <Typography
              variant="h2"
              sx={{
                fontSize: {
                  xs: 20,
                  sm: 28,
                  md: 32,
                  lg: 38,
                },
                fontWeight: 600,
                mb: 1,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              Transparent Cost Comparison
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: {
                  xs: 16,
                  sm: 18,
                  md: 18,
                  lg: 20,
                  xl: 22,
                },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
                textAlign: 'center',
              }}
            >
              Exactly what you pay to file each return type - no hidden
              fees.{' '}
            </Typography>
          </Grid>
          <Box
            sx={{ py: 4, px: { xs: 2, md: 4 }, maxWidth: '1000px', mx: 'auto' }}
          >
            <Stack
              spacing={4}
              direction={{ xs: 'column', md: 'row' }}
              sx={{ mt: 0 }}
            >
              <Box
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: 4,
                  border: '1px solid #16A34A',
                  width: '100%',
                  textAlign: 'center',
                  boxShadow:
                    '0 4px 20px rgba(0, 0, 0, .09), 0 1px 4px rgba(0, 0, 0, .05);',
                }}
              >
                <Stack
                  sx={{
                    borderBottom: '1px solid #E5E7EB',
                    p: { xs: 2, sm: 2 },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: 16, sm: 16 },
                      mb: 0.8,
                      color: '#087A42',
                    }}
                  >
                    TaxZerone
                  </Typography>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: 16, sm: 18 },
                    }}
                  >
                    Simple, Flat Pricing
                  </Typography>
                </Stack>
                <Stack spacing={1.8} sx={{ p: { xs: 2.5, sm: 3 } }}>
                  <Box
                    sx={{
                      width: '100%',
                      border: '1px solid #A7EFC5',
                      borderRadius: '14px',
                      backgroundColor: '#F0FFF6',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      px: 2,
                      py: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: 600,
                        letterSpacing: 0.8,
                        color: '#087A42',
                        mb: 0.5,
                      }}
                    >
                      FORM 990-N
                    </Typography>
                    <Typography
                      sx={{
                        letterSpacing: 0.8,
                        mb: 0.5,
                        fontWeight: 600,
                        fontSize: { xs: 16, sm: 16, md: 18, lg: 20 },
                      }}
                    >
                      $9.90{' '}
                      <span
                        style={{
                          fontSize: 14,
                          color: '#637381',
                          fontWeight: 400,
                        }}
                      >
                        / Per filing
                      </span>
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      border: '1px solid #E5E7EB',
                      borderRadius: '14px',
                      backgroundColor: '#F8F9FA',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      px: 2,
                      py: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: 600,
                        letterSpacing: 0.8,
                        mb: 0.5,
                      }}
                    >
                      FORM 990-EZ
                    </Typography>
                    <Typography
                      sx={{
                        letterSpacing: 0.8,
                        mb: 0.5,
                        fontWeight: 600,
                        fontSize: { xs: 16, sm: 16, md: 18, lg: 20 },
                      }}
                    >
                      $89.99{' '}
                      <span
                        style={{
                          fontSize: 14,
                          color: '#637381',
                          fontWeight: 400,
                        }}
                      >
                        / Per filing
                      </span>
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      border: '1px solid #E5E7EB',
                      borderRadius: '14px',
                      backgroundColor: '#F8F9FA',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      px: 2,
                      py: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: 600,
                        letterSpacing: 0.8,
                        mb: 0.5,
                      }}
                    >
                      FORM 990
                    </Typography>
                    <Typography
                      sx={{
                        letterSpacing: 0.8,
                        mb: 0.5,
                        fontWeight: 600,
                        fontSize: { xs: 16, sm: 16, md: 18, lg: 20 },
                      }}
                    >
                      $179.99{' '}
                      <span
                        style={{
                          fontSize: 14,
                          color: '#637381',
                          fontWeight: 400,
                        }}
                      >
                        / Per filing
                      </span>
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      border: '1px solid #E5E7EB',
                      borderRadius: '14px',
                      backgroundColor: '#F8F9FA',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      px: 2,
                      py: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: 600,
                        letterSpacing: 0.8,
                        mb: 0.5,
                      }}
                    >
                      FORM 990-PF
                    </Typography>
                    <Typography
                      sx={{
                        letterSpacing: 0.8,
                        mb: 0.5,
                        fontWeight: 600,
                        fontSize: { xs: 16, sm: 16, md: 18, lg: 20 },
                      }}
                    >
                      $149.99{' '}
                      <span
                        style={{
                          fontSize: 14,
                          color: '#637381',
                          fontWeight: 400,
                        }}
                      >
                        / Per filing
                      </span>
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      border: '1px solid #E5E7EB',
                      borderRadius: '14px',
                      backgroundColor: '#F8F9FA',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      px: 2,
                      py: 1,
                      mb: '14px !important',
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: 600,
                        letterSpacing: 0.8,
                        mb: 0.5,
                      }}
                    >
                      FORM 990-T
                    </Typography>
                    <Typography
                      sx={{
                        letterSpacing: 0.8,
                        mb: 0.5,
                        fontWeight: 600,
                        fontSize: { xs: 16, sm: 16, md: 18, lg: 20 },
                      }}
                    >
                      $129.99{' '}
                      <span
                        style={{
                          fontSize: 14,
                          color: '#637381',
                          fontWeight: 400,
                        }}
                      >
                        / Per filing
                      </span>
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Box
                      component="span"
                      sx={{
                        width: 22,
                        height: 22,
                        borderRadius: '50%',
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          color: '#16A34A',
                          fontSize: 14,
                          fontWeight: 600,
                          lineHeight: 1,
                        }}
                      >
                        ✓
                      </Box>
                    </Box>

                    <Box sx={{ fontSize: 14 }}>
                      Free to prepare - pay only to transmit
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Box
                      component="span"
                      sx={{
                        width: 22,
                        height: 22,
                        borderRadius: '50%',
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          color: '#16A34A',
                          fontSize: 14,
                          fontWeight: 600,
                          lineHeight: 1,
                        }}
                      >
                        ✓
                      </Box>
                    </Box>

                    <Box sx={{ fontSize: 14 }}>All schedules included free</Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Box
                      component="span"
                      sx={{
                        width: 22,
                        height: 22,
                        borderRadius: '50%',
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          color: '#16A34A',
                          fontSize: 14,
                          fontWeight: 600,
                          lineHeight: 1,
                        }}
                      >
                        ✓
                      </Box>
                    </Box>

                    <Box sx={{ fontSize: 14 }}>
                      Free retransmission on rejection
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Box
                      component="span"
                      sx={{
                        width: 22,
                        height: 22,
                        borderRadius: '50%',
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          color: '#16A34A',
                          fontSize: 14,
                          fontWeight: 600,
                          lineHeight: 1,
                        }}
                      >
                        ✓
                      </Box>
                    </Box>

                    <Box sx={{ fontSize: 14 }}>
                      No subscription or annual fees
                    </Box>
                  </Box>
                </Stack>
              </Box>
              <Box
                sx={{
                  borderRadius: 5,
                  border: '1px solid #E2E8F0',
                  width: '100%',
                  textAlign: 'center',
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                }}
              >
                <Stack
                  sx={{
                    borderBottom: '1px solid #E5E7EB',
                    p: { xs: 2, sm: 2 },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: 16, sm: 16 },
                      mb: 0.8,
                      color: '#637381',
                    }}
                  >
                    Simple990
                  </Typography>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: 16, sm: 18 },
                    }}
                  >
                    Per-Filing Pricing
                  </Typography>
                </Stack>
                <Stack spacing={1.8} sx={{ p: { xs: 2.5, sm: 3 } }}>
                  <Box
                    sx={{
                      width: '100%',
                      border: '1px solid #E5E7EB',
                      borderRadius: '14px',
                      backgroundColor: '#F8F9FA',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      px: 2,
                      py: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: 600,
                        letterSpacing: 0.8,
                        color: '#637381',
                        mb: 0.5,
                      }}
                    >
                      FORM 990-N
                    </Typography>
                    <Typography
                      sx={{
                        letterSpacing: 0.8,
                        mb: 0.5,
                        fontWeight: 600,
                        fontSize: { xs: 16, sm: 16, md: 18, lg: 20 },
                      }}
                    >
                      $50{' '}
                      <span
                        style={{
                          fontSize: 14,
                          color: '#637381',
                          fontWeight: 400,
                        }}
                      >
                        / notice
                      </span>
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      border: '1px solid #E5E7EB',
                      borderRadius: '14px',
                      backgroundColor: '#F8F9FA',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      px: 2,
                      py: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: 600,
                        letterSpacing: 0.8,
                        mb: 0.5,
                        color: '#637381',
                      }}
                    >
                      FORM 990-EZ
                    </Typography>
                    <Typography
                      sx={{
                        letterSpacing: 0.8,
                        mb: 0.5,
                        fontWeight: 600,
                        fontSize: { xs: 16, sm: 16, md: 18, lg: 20 },
                      }}
                    >
                      $90{' '}
                      <span
                        style={{
                          fontSize: 14,
                          color: '#637381',
                          fontWeight: 400,
                        }}
                      >
                        / Per filing
                      </span>
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      border: '1px solid #E5E7EB',
                      borderRadius: '14px',
                      backgroundColor: '#F8F9FA',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      px: 2,
                      py: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: 600,
                        letterSpacing: 0.8,
                        mb: 0.5,
                        color: '#637381',
                      }}
                    >
                      FORM 990
                    </Typography>
                    <Typography
                      sx={{
                        letterSpacing: 0.8,
                        mb: 0.5,
                        fontWeight: 600,
                        fontSize: { xs: 16, sm: 16, md: 18, lg: 20 },
                      }}
                    >
                      $180{' '}
                      <span
                        style={{
                          fontSize: 14,
                          color: '#637381',
                          fontWeight: 400,
                        }}
                      >
                        / return
                      </span>
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      border: '1px solid #F2CBCF',
                      borderRadius: '14px',
                      backgroundColor: '#FCEEEF',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      px: 2,
                      py: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: 600,
                        letterSpacing: 0.8,
                        mb: 0.5,
                        color: '#C63C4A',
                      }}
                    >
                      FORM 990-PF
                    </Typography>
                    <Typography
                      sx={{
                        letterSpacing: 0.8,
                        mb: 0.5,
                        fontWeight: 500,
                        fontSize: 14,
                        color: '#637381',
                      }}
                    >
                      Not supported
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      border: '1px solid #F2CBCF',
                      borderRadius: '14px',
                      backgroundColor: '#FCEEEF',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      px: 2,
                      py: 1,
                      mb: '14px !important',
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: 600,
                        letterSpacing: 0.8,
                        mb: 0.5,
                        color: '#C63C4A',
                      }}
                    >
                      FORM 990-T
                    </Typography>
                    <Typography
                      sx={{
                        letterSpacing: 0.8,
                        mb: 0.5,
                        fontWeight: 500,
                        fontSize: 14,
                        color: '#637381',
                      }}
                    >
                      Not supported
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      border: '1px solid #f2e2cb',
                      borderRadius: '14px',
                      backgroundColor: '#fcf5ee',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      px: 2,
                      py: 1,
                      mb: '14px !important',
                    }}
                  >
                    <Typography
                      sx={{
                        letterSpacing: 0.8,
                        mb: 0.5,
                        fontSize: 14,
                        color: '#bf7c14',
                      }}
                    >
                      ⚠ Simple990 pricing is a placeholder. Update once
                      confirmed from their website.
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Box
                      component="span"
                      sx={{
                        width: 22,
                        height: 22,
                        borderRadius: '50%',
                        backgroundColor: '#FCEEEF',
                        border: '1px solid #F2CBCF',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          color: '#C63C4A',
                          fontSize: 14,
                          fontWeight: 600,
                          lineHeight: 1,
                        }}
                      >
                        x
                      </Box>
                    </Box>
                    <Box sx={{ fontSize: 14 }}>
                      990-N costs $50 more than TaxZerone
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Box
                      component="span"
                      sx={{
                        width: 22,
                        height: 22,
                        borderRadius: '50%',
                        backgroundColor: '#FCEEEF',
                        border: '1px solid #F2CBCF',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          color: '#C63C4A',
                          fontSize: 14,
                          fontWeight: 600,
                          lineHeight: 1,
                        }}
                      >
                        x
                      </Box>
                    </Box>

                    <Box sx={{ fontSize: 14 }}>No 990-PF, 990-T support</Box>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Box
                      component="span"
                      sx={{
                        width: 22,
                        height: 22,
                        borderRadius: '50%',
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          color: '#16A34A',
                          fontSize: 14,
                          fontWeight: 600,
                          lineHeight: 1,
                        }}
                      >
                        ✓
                      </Box>
                    </Box>

                    <Box sx={{ fontSize: 14 }}>Free retransmission</Box>
                  </Box>
                </Stack>
              </Box>
            </Stack>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="xl" sx={{ mb: 5, mt: 5 }}>
          <Grid size={12} textAlign="center">
            <Box
              sx={{
                textAlign: 'center',
                px: 3,
                py: 0.8,
                mb: 1.5,
                borderRadius: '30px',
                backgroundColor: '#effff4',
                color: '#1da94a',
                border: '1px solid #1da94a',
                fontWeight: 600,
                display: 'inline-block',
              }}
            >
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: { xs: 12, sm: 13, md: 14 },
                  letterSpacing: '0.5px',
                  lineHeight: 1.2,
                }}
              >
                Forms Coverage
              </Typography>
            </Box>
            <Typography
              variant="h2"
              sx={{
                fontSize: {
                  xs: 20,
                  sm: 28,
                  md: 32,
                  lg: 38,
                },
                fontWeight: 600,
                mb: 1,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              Which Forms Does Each Platform Support?
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: {
                  xs: 16,
                  sm: 18,
                  md: 18,
                  lg: 20,
                  xl: 22,
                },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
                textAlign: 'center',
              }}
            >
              TaxZerone covers the full spectrum of exempt org returns.
              simple990 is limited to 990-EZ and full 990.{' '}
            </Typography>
          </Grid>
          <Box
            sx={{ py: 4, px: { xs: 2, md: 4 }, maxWidth: '1400px', mx: 'auto' }}
          >
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    borderRadius: '12px',
                    justifyContent: 'space-between',
                    minHeight: '100%',
                    p: 2,
                    backgroundColor: '#f6f6fa',
                  }}
                >
                  <Box sx={{}}>
                    <Typography
                      sx={{
                        fontSize: 16,
                        fontWeight: 600,
                        mb: 0.8,
                      }}
                    >
                      Form 990-N
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        lineHeight: 1.45,
                        color: '#6B7280',
                        mb: 1.2,
                      }}
                    >
                      Annual e-Postcard for small nonprofits with gross receipts
                      ≤ $50K
                    </Typography>
                  </Box>

                  <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}
                  >
                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.5,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#1da94a' }}>
                        TaxZerone &nbsp;✓
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.5,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#1da94a' }}>
                        Simple990 &nbsp;✓
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    borderRadius: '12px',
                    justifyContent: 'space-between',
                    minHeight: '100%',
                    p: 2,
                    backgroundColor: '#f6f6fa',
                  }}
                >
                  <Box sx={{}}>
                    <Typography
                      sx={{
                        fontSize: 16,
                        fontWeight: 600,
                        mb: 0.8,
                      }}
                    >
                      Form 990-EZ
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        lineHeight: 1.45,
                        color: '#6B7280',
                        mb: 1.2,
                      }}
                    >
                      Short-form return for mid-size orgs (gross receipts &lt;
                      $200K)
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}
                  >
                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.5,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#1da94a' }}>
                        TaxZerone &nbsp;✓
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.1,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#1da94a' }}>
                        Simple990 &nbsp;✓
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    borderRadius: '12px',
                    justifyContent: 'space-between',
                    minHeight: '100%',
                    p: 2,
                    backgroundColor: '#f6f6fa',
                  }}
                >
                  <Box sx={{}}>
                    <Typography
                      sx={{
                        fontSize: 16,
                        fontWeight: 600,
                        mb: 0.8,
                      }}
                    >
                      Form 990
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        lineHeight: 1.45,
                        color: '#6B7280',
                        mb: 1.2,
                      }}
                    >
                      Full return for larger nonprofits with gross receipts ≥
                      $200K
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}
                  >
                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.5,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#1da94a' }}>
                        TaxZerone &nbsp;✓
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.5,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#1da94a' }}>
                        Simple990 &nbsp;✓
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    borderRadius: '12px',
                    justifyContent: 'space-between',
                    minHeight: '100%',
                    p: 2,
                    backgroundColor: '#f6f6fa',
                  }}
                >
                  <Box sx={{}}>
                    <Typography
                      sx={{
                        fontSize: 16,
                        fontWeight: 600,
                        mb: 0.8,
                      }}
                    >
                      Form 990-PF
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        lineHeight: 1.45,
                        color: '#6B7280',
                        mb: 1.2,
                      }}
                    >
                      Return of private foundation regardless of financial size
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}
                  >
                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.5,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#1da94a' }}>
                        TaxZerone &nbsp;✓
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.1,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#FCEEEF',

                        border: '1px solid #C63C4A',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#C63C4A' }}>
                        Simple990 &nbsp;x
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    borderRadius: '12px',
                    justifyContent: 'space-between',
                    minHeight: '100%',
                    backgroundColor: '#f6f6fa',
                    p: 2,
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontSize: 16,
                        fontWeight: 600,
                        mb: 0.8,
                      }}
                    >
                      Form 990-T
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        lineHeight: 1.45,
                        color: '#6B7280',
                        mb: 1.2,
                      }}
                    >
                      Exempt org business income tax return (unrelated business
                      income)
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}
                  >
                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.5,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#1da94a' }}>
                        TaxZerone &nbsp;✓
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.1,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#FCEEEF',

                        border: '1px solid #C63C4A',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#C63C4A' }}>
                        Simple990 &nbsp;x
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    borderRadius: '12px',
                    justifyContent: 'space-between',
                    minHeight: '100%',
                    p: 2,
                    backgroundColor: '#f6f6fa',
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontSize: 16,
                        fontWeight: 600,
                        mb: 0.8,
                      }}
                    >
                      Form 1120-POL
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        lineHeight: 1.45,
                        color: '#6B7280',
                        mb: 1.2,
                      }}
                    >
                      Political organization income tax return
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}
                  >
                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.5,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#1da94a' }}>
                        TaxZerone &nbsp;✓
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.1,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#FCEEEF',

                        border: '1px solid #C63C4A',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#C63C4A' }}>
                        Simple990 &nbsp;x
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    borderRadius: '12px',
                    justifyContent: 'space-between',
                    minHeight: '100%',
                    p: 2,
                    backgroundColor: '#f6f6fa',
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontSize: 16,
                        fontWeight: 600,
                        mb: 0.8,
                      }}
                    >
                      Form 5227
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        lineHeight: 1.45,
                        color: '#6B7280',
                        mb: 1.2,
                      }}
                    >
                      Split-interest trust information return
                    </Typography>
                  </Box>

                  <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}
                  >
                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.5,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#1da94a' }}>
                        TaxZerone &nbsp;✓
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.1,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#FCEEEF',

                        border: '1px solid #C63C4A',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#C63C4A' }}>
                        Simple990 &nbsp;x
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    borderRadius: '12px',
                    justifyContent: 'space-between',
                    minHeight: '100%',
                    p: 2,
                    backgroundColor: '#f6f6fa',
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontSize: 16,
                        fontWeight: 600,
                        mb: 0.8,
                      }}
                    >
                      Form 8868
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        lineHeight: 1.45,
                        color: '#6B7280',
                        mb: 1.2,
                      }}
                    >
                      Extension of time to file exempt organization returns
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}
                  >
                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.5,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#1da94a' }}>
                        TaxZerone &nbsp;✓
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.1,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#FCEEEF',

                        border: '1px solid #C63C4A',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#C63C4A' }}>
                        Simple990 &nbsp;x
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    borderRadius: '12px',
                    justifyContent: 'space-between',
                    minHeight: '100%',
                    p: 2,
                    backgroundColor: '#f6f6fa',
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontSize: 16,
                        fontWeight: 600,
                        mb: 0.8,
                      }}
                    >
                      Form 8050
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        lineHeight: 1.45,
                        color: '#6B7280',
                        mb: 1.2,
                      }}
                    >
                      Direct deposit of corporate tax refund
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}
                  >
                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.5,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#1da94a' }}>
                        TaxZerone &nbsp;✓
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.1,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#FCEEEF',

                        border: '1px solid #C63C4A',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#C63C4A' }}>
                        Simple990 &nbsp;x
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    borderRadius: '12px',
                    justifyContent: 'space-between',
                    minHeight: '100%',
                    p: 2,
                    backgroundColor: '#f6f6fa',
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontSize: 16,
                        fontWeight: 600,
                        mb: 0.8,
                      }}
                    >
                      CA Form 199
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        lineHeight: 1.45,
                        color: '#6B7280',
                        mb: 1.2,
                      }}
                    >
                      California exempt organization annual return (state
                      filing)
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}
                  >
                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.5,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#1da94a' }}>
                        TaxZerone &nbsp;✓
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.1,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#FCEEEF',

                        border: '1px solid #C63C4A',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#C63C4A' }}>
                        Simple990 &nbsp;x
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    borderRadius: '12px',
                    justifyContent: 'space-between',
                    minHeight: '100%',
                    p: 2,
                    backgroundColor: '#f6f6fa',
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontSize: 16,
                        fontWeight: 600,
                        mb: 0.8,
                      }}
                    >
                      CA Form 109
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 14,
                        lineHeight: 1.45,
                        color: '#6B7280',
                        mb: 1.2,
                      }}
                    >
                      California Exempt Organization Business Income Tax Return
                      (state filing)
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}
                  >
                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.5,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#e7f7ef',
                        border: '1px solid #bee9d1',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#1da94a' }}>
                        TaxZerone &nbsp;✓
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'inline-flex',
                        width: 'fit-content',
                        px: 1.1,
                        py: 0.35,
                        borderRadius: 10,
                        backgroundColor: '#FCEEEF',

                        border: '1px solid #C63C4A',
                      }}
                    >
                      <Typography sx={{ fontSize: 12, color: '#C63C4A' }}>
                        Simple990 &nbsp;x
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f6f6fa',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Box
              sx={{
                pt: 6,
                px: 2,
                maxWidth: '1200px',
                mx: 'auto',
                textAlign: 'center',
              }}
            >
              <Box textAlign="center" sx={{ mb: 1 }}>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,

                    mb: 0,
                  }}
                >
                  Trusted by Organizations Like Yours
                </Typography>
              </Box>

              <Grid container spacing={0} sx={{ mt: 0 }}>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{
                    border: '1px solid #ccc',
                  }}
                >
                  <Box
                    component="a"
                    href="https://www.trustpilot.com/review/taxzerone.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      mt: 0,
                      display: 'inline-flex',
                      alignItems: 'center',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      transition: 'transform 0.2s ease',
                      justifyContent: 'center',
                      textAlign: 'center',
                      mx: 'auto',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        pr: 1.5,
                        mr: 1.5,
                        borderRight: '1px solid #e5e7eb',
                        height: 48,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: 20, sm: 23 },
                          fontWeight: 600,
                          fontFamily: 'Arial, sans-serif',
                          color: '#00b67a',
                          letterSpacing: '-0.5px',
                          lineHeight: 1,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Trustpilot
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                      }}
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={0.7}
                        sx={{
                          height: 20,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#172b4d',
                            lineHeight: 1,
                          }}
                        >
                          Excellent
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#172b4d',
                            lineHeight: 1,
                          }}
                        >
                          4.4
                        </Typography>
                      </Stack>

                      <Stack
                        direction="row"
                        spacing={0.35}
                        sx={{
                          mt: 0.6,
                        }}
                      >
                        {/* Star 1 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 2 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 3 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 4 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 5 - 40% for 4.4 rating */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            position: 'relative',
                            overflow: 'hidden',
                            backgroundColor: '#d9d9d9',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {/* Grey Star */}
                          <Typography
                            sx={{
                              position: 'absolute',
                              color: '#ffffff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>

                          {/* Green 40% Star */}
                          <Box
                            sx={{
                              position: 'absolute',
                              left: 0,
                              top: 0,
                              width: '40%',
                              height: '100%',
                              overflow: 'hidden',
                              backgroundColor: '#00b67a',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                            }}
                          >
                            <Typography
                              sx={{
                                width: 20,
                                minWidth: 20,
                                color: '#ffffff',
                                fontSize: 14,
                                lineHeight: 1,
                                textAlign: 'center',
                              }}
                            >
                              ★
                            </Typography>
                          </Box>
                        </Box>
                      </Stack>
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{ border: '1px solid #ccc', borderLeft: 'unset' }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      textAlign: 'left',
                      gap: 1.2,
                      justifyContent: 'center',
                    }}
                  >
                    <Box>
                      <picture>
                        <source srcSet="/assets/images/google-reviews.webp" />
                        <source srcSet="/assets/images/google-reviews.png" />
                        <Box
                          component="img"
                          src="/assets/images/google-reviews.png"
                          loading="lazy"
                          alt="Google Review"
                          width={53}
                          height={58}
                          sx={{
                            width: { xs: 50, md: 53 },
                            height: { xs: 49, md: 58 },
                          }}
                        />
                      </picture>
                    </Box>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Reviews 5.0
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#EAB308' }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{
                    border: '1px solid #ccc',
                    borderLeft: 'unset',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      textAlign: 'left',
                      gap: 1.2,
                      justifyContent: 'center',
                    }}
                  >
                    <Box>
                      <picture>
                        <source srcSet="/assets/images/g2-logo-img.webp" />
                        <source srcSet="/assets/images/g2-logo-img.png" />
                        <Box
                          component="img"
                          src="/assets/images/g2-logo-img.png"
                          loading="lazy"
                          alt="G2 logo"
                          width={53}
                          height={58}
                          sx={{
                            width: { xs: 50, md: 53 },
                            height: { xs: 49, md: 58 },
                          }}
                        />
                      </picture>
                    </Box>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Reviews 5.0
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#EAB308' }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        I wanted a filing platform that was clear about what I
                        was getting and what I would pay. TaxZerone made the
                        comparison much easier and the filing process was
                        smooth.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Lisa 
                      </Typography>
                    </Paper>

                    {/* <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#E0F2FE', // Light blue fill
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        The phone support team was really patient and walked me
                        through everything step by step. I had no tax knowledge
                        at all going in. TaxZerone made the whole process feel
                        easy and gave me confidence. 10/10.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Elizabeth Wagner
                      </Typography>
                    </Paper> */}
                  </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#e2dafc',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        Our organization files multiple returns each year, and
                        keeping everything organized can be a challenge.
                        TaxZerone helps us stay on top of our filings and track
                        our return status
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Jennifer P
                      </Typography>
                    </Paper>
                    {/* 
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        Really good chat support experience. I wasn&apos;t sure
                        how to complete a few steps, but Kevin guided me clearly
                        and stayed with me until everything was done. Appreciate
                        the help.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Joseph J Perez
                      </Typography>
                    </Paper> */}
                  </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        What stood out to me was transparency. I could see the
                        filing options and understand the process before getting
                        started. That made choosing a platform much easier
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Michael
                      </Typography>
                    </Paper>

                    {/* <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#FEF3C7', // Light yellow fill
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        OMG! I cannot believe how wonderful the live support
                        was. The agent Alexia assisted me with everything I
                        needed and fixed all the issues in the most professional
                        and friendly manner. Amazing customer experience. Thank
                        You!
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Luis Echenique
                      </Typography>
                    </Paper> */}
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Container>
      </Grid>
      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.2,
          }}
        >
          You’ve Compared the Options - Now Make an Informed Choice
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: {
              xs: 16,
              sm: 18,
              md: 18,
              lg: 20,
              xl: 22,
            },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          E-filing exempt organization returns should be simple, secure, and
          transparent. <br />
          Choose a platform that simplifies the filing process, provides the
          features you need,
          <br />{' '}
          <Hidden smDown>
            safeguards your data, and offers clear, predictable pricing.{' '}
          </Hidden>{' '}
        </Typography>
        <Box
          sx={{
            width: '100%',
            maxWidth: { xs: '100%', lg: 900 },
            mx: 'auto',
            py: 2,
            px: { xs: 1, sm: 0 },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              gap: 2,
              justifyContent: 'center',
              alignItems: 'stretch',
              width: '100%',
            }}
          >
            {/* Card 1 */}
            <Box
              sx={{
                px: 2,
                py: 2,
                width: { xs: '100%', sm: 280 },
                maxWidth: { xs: '100%', sm: 280 },
                boxSizing: 'border-box',
                flexShrink: 1,
                background: 'rgba(255, 255, 255, 0.14)',
                backdropFilter: 'blur(8px)',
                borderRadius: 4,
                border: '1px solid rgba(255, 255, 255, 0.3)',
                overflow: 'hidden',
                position: 'relative',

                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '1px',
                  background:
                    'linear-gradient(45deg, transparent, rgba(255,255,255,0.8), transparent)',
                },

                '&::after': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '1px',
                  height: '100%',
                  background:
                    'linear-gradient(180deg, rgba(255,255,255,0.8), transparent, rgba(255,255,255,0.3))',
                },
              }}
            >
              <Typography
                sx={{
                  color: '#fff',
                  textAlign: 'center',
                  fontSize: { xs: 14, sm: 15, md: 16 },
                }}
              >
                Supports IRS Forms Across the Exempt Organization Family
              </Typography>
            </Box>

            {/* Card 2 */}
            <Box
              sx={{
                px: 2,
                py: 2,
                width: { xs: '100%', sm: 280 },
                maxWidth: { xs: '100%', sm: 280 },
                boxSizing: 'border-box',
                flexShrink: 1,
                background: 'rgba(255, 255, 255, 0.14)',
                backdropFilter: 'blur(8px)',
                borderRadius: 4,
                border: '1px solid rgba(255, 255, 255, 0.3)',
                overflow: 'hidden',
                position: 'relative',

                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '1px',
                  background:
                    'linear-gradient(45deg, transparent, rgba(255,255,255,0.8), transparent)',
                },

                '&::after': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '1px',
                  height: '100%',
                  background:
                    'linear-gradient(180deg, rgba(255,255,255,0.8), transparent, rgba(255,255,255,0.3))',
                },
              }}
            >
              <Typography
                sx={{
                  color: '#fff',
                  textAlign: 'center',
                  fontSize: { xs: 14, sm: 15, md: 16 },
                }}
              >
                <strong style={{ fontWeight: 600 }}>
                  {' '}
                  Free retransmission{' '}
                </strong>{' '}
                if your return is rejected
              </Typography>
            </Box>

            {/* Card 3 */}
            <Box
              sx={{
                px: 2,
                py: 2,
                width: { xs: '100%', sm: 280 },
                maxWidth: { xs: '100%', sm: 280 },
                boxSizing: 'border-box',
                flexShrink: 1,
                background: 'rgba(255, 255, 255, 0.14)',
                backdropFilter: 'blur(8px)',
                borderRadius: 4,
                border: '1px solid rgba(255, 255, 255, 0.3)',
                overflow: 'hidden',
                position: 'relative',

                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '1px',
                  background:
                    'linear-gradient(45deg, transparent, rgba(255,255,255,0.8), transparent)',
                },

                '&::after': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '1px',
                  height: '100%',
                  background:
                    'linear-gradient(180deg, rgba(255,255,255,0.8), transparent, rgba(255,255,255,0.3))',
                },
              }}
            >
              <Typography
                sx={{
                  color: '#fff',
                  textAlign: 'center',
                  fontSize: { xs: 14, sm: 15, md: 16 },
                }}
              >
                <strong style={{ fontWeight: 600 }}>
                  {' '}
                  Easy-to-follow filing workflow{' '}
                </strong>{' '}
              </Typography>
            </Box>

            {/* Card 4 */}
            <Box
              sx={{
                px: 2,
                py: 2,
                width: { xs: '100%', sm: 280 },
                maxWidth: { xs: '100%', sm: 280 },
                boxSizing: 'border-box',
                flexShrink: 1,
                background: 'rgba(255, 255, 255, 0.14)',
                backdropFilter: 'blur(8px)',
                borderRadius: 4,
                border: '1px solid rgba(255, 255, 255, 0.3)',
                overflow: 'hidden',
                position: 'relative',

                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '1px',
                  background:
                    'linear-gradient(45deg, transparent, rgba(255,255,255,0.8), transparent)',
                },

                '&::after': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '1px',
                  height: '100%',
                  background:
                    'linear-gradient(180deg, rgba(255,255,255,0.8), transparent, rgba(255,255,255,0.3))',
                },
              }}
            >
              <Typography
                sx={{
                  color: '#fff',
                  textAlign: 'center',
                  fontSize: { xs: 14, sm: 15, md: 16 },
                }}
              >
                <strong style={{ fontWeight: 600 }}>
                  {' '}
                  SOC 2 certified
                  <br />{' '}
                </strong>{' '}
                security
              </Typography>
            </Box>

            {/* Card 5 */}
            <Box
              sx={{
                px: 2,
                py: 2,
                width: { xs: '100%', sm: 280 },
                maxWidth: { xs: '100%', sm: 280 },
                boxSizing: 'border-box',
                flexShrink: 1,
                background: 'rgba(255, 255, 255, 0.14)',
                backdropFilter: 'blur(8px)',
                borderRadius: 4,
                border: '1px solid rgba(255, 255, 255, 0.3)',
                overflow: 'hidden',
                position: 'relative',

                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '1px',
                  background:
                    'linear-gradient(45deg, transparent, rgba(255,255,255,0.8), transparent)',
                },

                '&::after': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '1px',
                  height: '100%',
                  background:
                    'linear-gradient(180deg, rgba(255,255,255,0.8), transparent, rgba(255,255,255,0.3))',
                },
              }}
            >
              <Typography
                sx={{
                  color: '#fff',
                  textAlign: 'center',
                  fontSize: { xs: 14, sm: 15, md: 16 },
                }}
              >
                <strong style={{ fontWeight: 600 }}>
                  {' '}
                  Transparent pricing{' '}
                </strong>{' '}
                with no subscription or hidden fees
              </Typography>
            </Box>

            {/* Card 6 */}
            <Box
              sx={{
                px: 2,
                py: 2,
                width: { xs: '100%', sm: 280 },
                maxWidth: { xs: '100%', sm: 280 },
                boxSizing: 'border-box',
                flexShrink: 1,
                background: 'rgba(255, 255, 255, 0.14)',
                backdropFilter: 'blur(8px)',
                borderRadius: 4,
                border: '1px solid rgba(255, 255, 255, 0.3)',
                overflow: 'hidden',
                position: 'relative',

                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '1px',
                  background:
                    'linear-gradient(45deg, transparent, rgba(255,255,255,0.8), transparent)',
                },

                '&::after': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '1px',
                  height: '100%',
                  background:
                    'linear-gradient(180deg, rgba(255,255,255,0.8), transparent, rgba(255,255,255,0.3))',
                },
              }}
            >
              <Typography
                sx={{
                  color: '#fff',
                  textAlign: 'center',
                  fontSize: { xs: 14, sm: 15, md: 16 },
                }}
              >
                <strong style={{ fontWeight: 600 }}> IRS-authorized </strong>{' '}
                e-file provider
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 2 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=taxzerone-vs-simple990`}
          >
            Start Filling on TaxZerone
          </Button>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 3,
              mt: 2,
              flexWrap: 'wrap',
            }}
          >
            <Typography sx={{ color: '#f3f3f3' }}>
              No subscription. No hidden fees.
            </Typography>
          </Box>
        </Box>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#ffffff',
          mx: '0 !important',
          width: '100% !important',
          py: 2,
        }}
        spacing={0}
        m={0}
        component="section"
        aria-labelledby="comparison-faq"
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <Grid
            container
            spacing={2}
            m={2}
            direction="row"
            justifyContent="center"
            className="MuiGrid-root-width"
            sx={{ my: { xs: 0, sm: 2, md: 2 } }}
          >
            <Grid size={12} textAlign="center">
              <Box
                sx={{
                  textAlign: 'center',
                  px: 3,
                  py: 0.8,
                  mb: 1.5,
                  borderRadius: '30px',
                  backgroundColor: '#effff4',
                  color: '#1da94a',
                  border: '1px solid #1da94a',
                  fontWeight: 600,
                  display: 'inline-block',
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: { xs: 12, sm: 13, md: 14 },
                    letterSpacing: '0.5px',
                    lineHeight: 1.2,
                  }}
                >
                  FAQ
                </Typography>
              </Box>
              <Typography
                variant="h2"
                sx={{
                  fontSize: {
                    xs: 20,
                    sm: 28,
                    md: 32,
                    lg: 38,
                  },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Common Questions
              </Typography>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 10, md: 9 }}
              textAlign="left"
              mt={{ xs: 2, sm: 1 }}
              mb={2}
            >
              <Box
                component="div"
                sx={{ mb: 0 }}
                itemScope
                itemType="https://schema.org/FAQPage"
              >
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Can I file for an automatic 6-month extension if my
                    organization needs more time?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography
                      variant="body1"
                      itemProp="text"
                      sx={{ mb: 2, mt: 1 }}
                    >
                      Yes. TaxZerone supports electronic filing for Form 8868,
                      allowing exempt organizations to quickly request an
                      automatic 6-month extension before their filing deadline.
                    </Typography>
                  </Box>
                </Box>

                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    What happens if my tax-exempt return gets rejected by the
                    IRS? Is retransmission free?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography
                      variant="body1"
                      itemProp="text"
                      sx={{ mb: 2, mt: 1 }}
                    >
                      If the IRS rejects your tax-exempt return due to errors or
                      missing information, TaxZerone lets you correct the issues
                      and retransmit your return for{' '}
                      <strong style={{ fontWeight: 600 }}> free</strong>. You
                      will not be charged any additional fees to resubmit.
                    </Typography>
                  </Box>
                </Box>

                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Are there hidden fees for adding required IRS schedules
                    (e.g., Schedule A, B, or D)?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography
                      variant="body1"
                      itemProp="text"
                      sx={{ mb: 2, mt: 1 }}
                    >
                      <strong style={{ fontWeight: 600 }}>No.</strong>TaxZerone
                      features transparent pricing with{' '}
                      <strong style={{ fontWeight: 600 }}>
                        {' '}
                        no extra or hidden{' '}
                      </strong>{' '}
                      charges for adding required IRS supporting schedules. All
                      applicable schedules auto-generate based on your inputs
                      and are included in your standard filing price.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
    </AppLayout>
  );
};

export default taxzeronevssimple990;
